import React from 'react';
import { cn } from '@/lib/utils';

interface FlagProps {
  countryCode: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses = {
  sm: 'w-5 h-3.5',
  md: 'w-6 h-4',
  lg: 'w-8 h-6',
  xl: 'w-12 h-8',
};

export function Flag({ countryCode, className, size = 'md' }: FlagProps) {
  if (!countryCode) return null;

  const code = countryCode.toLowerCase();

  return (
    <span
      className={cn(
        'fi',
        `fi-${code}`,
        'inline-block',
        sizeClasses[size],
        className
      )}
      role="img"
      aria-label={`${countryCode} flag`}
    />
  );
}

export default Flag;
